import EditableLabel from '../../../../../../components/EditableLabel/EditableLabel'
import React, { useContext } from 'react'
import styles from './TitleField.module.css'
import { BuilderContext } from '../../../store/store.Builder'
import EditableDescription from '../../../../../../components/EditableDescription/EditableDescription'
const TitleField = ({ field }) => {
  const builderContext = useContext(BuilderContext)

  return <div></div>
}
export default TitleField
